import { useCallback, useEffect } from "react";

import classnames from "classnames";

import Modal from "react-modal";

import { Icon } from "@components/core/Icon";

export const Drawer = ({
  visible,
  title,
  subtitle,
  onClose,
  direction = "right",
  showCloseButton = true,
  showBackButton = false,
  backButton,
  children,
  footer,
  alreadyDrawer,
  closeInFade = true,
  closeValidation,
  withoutTransition,
  withoutScroll,
  withoutPadding,
  alert,
  parentSelector,
}) => {
  const handleCloseDrawer = useCallback(
    (status) => onClose && onClose(status),
    [onClose]
  );

  const handleBackButton = useCallback(() => {
    if (typeof backButton == "function") {
      backButton();
    } else {
      handleCloseDrawer(!visible);
    }
  }, [visible, backButton, handleCloseDrawer]);

  useEffect(() => {
    if (visible) {
      window.history.pushState(null, "", window.location.href);

      window.onpopstate = () => {
        window.onpopstate = undefined;
        handleCloseDrawer(!visible);
      };
    }
  }, [visible, handleCloseDrawer]);

  const beforeClose = async (e, closeInX) => {
    if (closeInX || closeInFade) {
      if (!closeValidation) {
        return handleCloseDrawer(false);
      }

      if (await closeValidation(e)) {
        return handleCloseDrawer(false);
      }
    }
  };

  const onCloseDrawer = () => {
    document.body.classList.remove("ReactModal__Body--open");
  };

  return (
    <Modal
      isOpen={visible}
      ariaHideApp={false}
      closeTimeoutMS={withoutTransition ? 0 : 500}
      onRequestClose={() => handleCloseDrawer(!visible)}
      className={{
        base: "drawer-base",
        afterOpen: "drawer-base_after-open",
        beforeClose: "drawer-base_before-close",
      }}
      overlayClassName={{
        base: "overlay-base",
        afterOpen: "overlay-base_after-open",
        beforeClose: "overlay-base_before-close",
      }}
      shouldReturnFocusAfterClose={false}
      preventScroll
      onAfterClose={() => !alreadyDrawer && onCloseDrawer()}
      parentSelector={parentSelector}
    >
      <div
        className={classnames({
          fade: true,
          alert: alert,
          alreadyDrawer: alreadyDrawer,
          withoutTransition: withoutTransition,
          [direction]: true,
        })}
        onClick={(e) => beforeClose(e, false)}
      />
      <div
        className={classnames({
          drawer: true,
          [direction]: true,
          withoutTransition: withoutTransition,
        })}
      >
        {(showCloseButton || showBackButton || title) && (
          <div className={`header`}>
            <div className="d-flex justify-center align-center w-100">
              {showBackButton && (
                <div className="back" onClick={() => handleBackButton()}>
                  <Icon name="long-arrow-left" size="1x" />
                </div>
              )}
              {showCloseButton && (
                <div className="close" onClick={(e) => beforeClose(e, true)}>
                  <Icon name="times" size="1x" />
                </div>
              )}
              <div className="d-flex flex-column align-center w-100">
                {title && <p className="title">{title}</p>}
                {subtitle && <p className="subtitle">{subtitle}</p>}
              </div>
            </div>
          </div>
        )}
        <div
          className={classnames({
            content: true,
            withoutScroll: withoutScroll,
          })}
        >
          {children}
        </div>
        {footer && <div className="footer">{footer}</div>}
      </div>
    </Modal>
  );
};
